import React, { useContext } from "react";
import { SyncStatusEunm } from "@/components/Joyspace/controllers/JoyspaceController";
import IconFont from "@/components/icon";
import "./index.less";
import { useNavigator } from "@/utils/NetworkCheck";
import GlobalContext from "@/context/GlobalContext";

interface IProps {
  status: SyncStatusEunm;
}

const SyncStatusTag = (props: IProps) => {
  const { status } = props;
  const { onLine } = useContext(GlobalContext);

  const tags = {
    [SyncStatusEunm.WAITING]: {
      text: onLine ? "正在等待同步" : "待联网后同步",
      icon: () => (
        <IconFont
          className="icon  sync-tags-icon"
          style={{ color: "#33D6BC" }}
          type="iconic_time_honer"
        />
      )
    },
    [SyncStatusEunm.PROCESS]: {
      text: "同步中…",
      icon: () => (
        <IconFont
          className="icon repeat-content-icon sync-tags-icon"
          style={{ color: "#508DFF" }}
          type="iconic_pc_calender_repeat"
        />
      )
    },
    [SyncStatusEunm.COMPLETE]: {
      text: "同步完成",
      icon: () => (
        <IconFont
          className="icon  sync-tags-icon"
          style={{ color: "#faab0d" }}
          type="iconic_pc_im_complete"
        />
      )
    },
    [SyncStatusEunm.ERROR]: {
      text: "同步失败",
      icon: () => (
        <IconFont
          className="icon  iconic_pc_im_close"
          style={{ color: "#ED6A0C" }}
          type="iconlog_del"
        />
      )
    },
    [SyncStatusEunm.DATAERROR]: {
      text: "同步数据异常",
      icon: () => (
        <IconFont
          className="icon  sync-tags-icon"
          style={{ color: "#F80000" }}
          type="iconic_failure"
        />
      )
    }
  };
  return (
    <span className="sync-tags">
      {tags[status]?.icon()}
      <span className="sync-tags-text">{tags[status].text}</span>
    </span>
  );
};

export default SyncStatusTag;
